import { create } from 'zustand';
import hospitalData from "./assets/data/hospitals_v6.json";


const useStore = create((set) => (
    {
        postcodeUser: '',
        postcodeResults: [],
        suburbUser: '',
        postcodeUserLong: '',
        postcodeUserLat: '',
        postcodeSelected: false,
        stateCode: '',
        hospitals: hospitalData,
        nearestHospitals: [],
        nswHospitals: [],
        actHospitals: [],
        qldHospitals: [],
        vicHospitals: [],
        tasHospitals: [],
        ntHospitals: [],
        waHospitals: [],
        saHospitals: [],
        
        completeHospitals: [],
        emergencyDepartmentHospitals: [],
        electiveSurgeryHospitals: [],
        partialServiceHospitals: [],

        setCompleteHospitals: (newHospital) => set((state) => ({completeHospitals: [...state.completeHospitals, newHospital]})),
        setEmergencyDepartmentHospitals: (newHospital) => set((state) => ({emergencyDepartmentHospitals: [...state.emergencyDepartmentHospitals, newHospital]})),
        setElectiveSurgeryHospitals: (newHospital) => set((state) => ({electiveSurgeryHospitals: [...state.electiveSurgeryHospitals, newHospital]})),
        setPartialServiceHospitals: (newHospital) => set((state) => ({partialServiceHospitals: [...state.partialServiceHospitals, newHospital]})),

        visibleItems: 5, 
        setVisibleItems: (number) => set((state) => ({visibleItems: number})),

        dataDetails: false,
        setDataDetails: (bool) => set((state) => ({dataDetails: bool})),

        setNswHospitals: (newHospital) => set((state) => ({nswHospitals: [...state.nswHospitals, newHospital]})),
        setActHospitals: (newHospital) => set((state) => ({actHospitals: [...state.actHospitals, newHospital]})),
        setQldHospitals: (newHospital) => set((state) => ({qldHospitals: [...state.qldHospitals, newHospital]})),
        setVicHospitals: (newHospital) => set((state) => ({vicHospitals: [...state.vicHospitals, newHospital]})),
        setTasHospitals: (newHospital) => set((state) => ({tasHospitals: [...state.tasHospitals, newHospital]})),
        setNtHospitals: (newHospital) => set((state) => ({ntHospitals: [...state.ntHospitals, newHospital]})),
        setWaHospitals: (newHospital) => set((state) => ({waHospitals: [...state.waHospitals, newHospital]})),
        setSaHospitals: (newHospital) => set((state) => ({saHospitals: [...state.saHospitals, newHospital]})),
        
        setPostcodeUser: (postcode) => set((state) => ({ postcodeUser: postcode })),
        setPostcodeResults: (results) => set((state) => ({ postcodeResults: results })),

        setSuburbUser: (suburb) => set((state) => ({ suburbUser: suburb })),

        setPostcodeUserLong: (long) => set((state) => ({ postcodeUserLong: long })),
        setPostcodeUserLat: (lat) => set((state) => ({ postcodeUserLat: lat })),

        setPostcodeSelected: (selected) => set((state) => ({ postcodeSelected: selected })),

        setStateCode: (stateCode) => set((state) => ({ stateCode: stateCode })),

        setHospitals: (hospitals) => set((state) => ({ hospitals: hospitals })),

        setNearestHospitals: (hospitals) => set((state) => ({ nearestHospitals: hospitals }))

    }
));

export default useStore;